import { Formik, ErrorMessage, Field, Form } from 'formik';
import { loginSchema, loginInitial } from '../../validations/authValidations';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { loginAction } from '../../stores/actions/authActions';
import { closeModal } from '../../stores/slices/commonSlice';
import { ArrowRight } from 'lucide-react';

const INPUT_CLASS =
  'w-full h-12 px-4 rounded-xl border border-gray-200 bg-white text-sm font-medium text-gray-900 placeholder:text-gray-400 outline-none transition-colors focus:border-gray-300 focus:ring-0 shadow-none';
const LABEL_CLASS = 'text-sm font-bold text-gray-700';
const ERROR_CLASS = 'text-red-500 text-xs mt-1.5 mb-0';

export default function LoginComponent({ onForgotPassword, onBusyChange }) {
  const [disabled, setDisabled] = useState(false);
  const [loginBtn, setLoginBtn] = useState('Login');
  const dispatch = useDispatch();

  const loginNormal = async (values) => {
    setDisabled(true);
    setLoginBtn('Please wait ...');
    // Tell the parent modal a login is in flight so it can show a blocking
    // overlay (prevents clicks/close while the request completes).
    onBusyChange?.(true);
    dispatch(loginAction(values))
      .then((response) => {
        setDisabled(false);
        setLoginBtn('Login');
        onBusyChange?.(false);
        if (response.meta.requestStatus === 'fulfilled') {
          dispatch(closeModal());
        }
      })
      .catch(() => {
        setDisabled(false);
        setLoginBtn('Login');
        onBusyChange?.(false);
      });
  };

  return (
    <Formik
      initialValues={loginInitial}
      validationSchema={loginSchema}
      onSubmit={(values) => {
        loginNormal(values);
      }}
    >
      <Form className="flex flex-col gap-3">
        <div>
          <label htmlFor="login-email" className={`${LABEL_CLASS} mb-1.5 block`}>
            Email
          </label>
          <Field
            id="login-email"
            type="email"
            name="email"
            placeholder="Email"
            className={INPUT_CLASS}
          />
          <ErrorMessage name="email" component="p" className={ERROR_CLASS} />
        </div>

        <div>
          <div className="mb-1.5 flex items-center justify-between gap-3">
            <label htmlFor="login-password" className={LABEL_CLASS}>
              Password
            </label>
            <button
              type="button"
              onClick={onForgotPassword}
              className="border-none bg-transparent p-0 text-xs font-semibold text-gray-600 transition-colors hover:text-gray-900"
            >
              Forgot Password?
            </button>
          </div>
          <Field
            id="login-password"
            type="password"
            name="password"
            placeholder="Password"
            className={INPUT_CLASS}
          />
          <ErrorMessage name="password" component="p" className={ERROR_CLASS} />
        </div>

        <button
          disabled={disabled}
          type="submit"
          className="w-full bg-[#ffea00] hover:bg-[#e6d300] gap-2 items-center border-none text-black font-black py-3 transition-all rounded-xl text-base shadow-md hover:shadow-lg active:scale-[0.98] flex justify-center items-center"
        >
          {loginBtn}
          {loginBtn === 'Login' && <ArrowRight size={16} strokeWidth={2.5} />}
        </button>
      </Form>
    </Formik>
  );
}
